/**
 * Created by mac on 4/6/24
 */

const LoadingAnimation = cleverapps.Spine.extend({
    ctor: function () {
        this._super(bundles.main.jsons.wait_json);
        const styles = cleverapps.styles.LoadingAnimation;

        this.setAnimation(0, "idle", true);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            this.setScale(styles.animation.verticalScale);
        }

        if (styles.text) {
            const loadingText = cleverapps.UI.generateOnlyText(Messages.has("Loading") ? Messages.get("Loading") : "Loading", cleverapps.styles.FONTS.LOADING_ANIMATION_TEXT);
            loadingText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            loadingText.setDimensions(styles.text.width, 0);
            loadingText.fitTo(undefined, styles.text.height);
            loadingText.setAlignment(styles.text);
            this.addChild(loadingText, 1);
        }
    },

    subscribeToModel: function () {
        cleverapps.loading.on("show", this.showLoading.bind(this), this);
        cleverapps.loading.on("hide", this.hideLoading.bind(this), this);
    },

    hideLoading: function () {
        this.stopAllActions();
        this.setVisible(false);
    },

    showLoading: function () {
        this.stopAllActions();
        this.runAction(
            new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.Show()
            )
        );
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LOADING_ANIMATION_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.WINDOW_WHITE_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.WHITE_TEXT_SHADOW
    }
});

cleverapps.styles.LoadingAnimation = {
    text: {
        x: { align: "center" },
        y: { align: "center" },

        width: 400,
        height: 70
    },

    animation: {
        verticalScale: 0.7
    }
};